import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

const FilterAccordion = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border-b border-stone-200">
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen((open) => !open);
        }}
        className="flex w-full items-center justify-between bg-transparent py-3 px-0 text-left"
      >
        <span className="font-sans text-[14px] leading-5 font-normal text-[#333333]">
          {title}
        </span>
        <ChevronDownIcon
          className={`h-4 w-4 text-[#333333] transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </button>
      {isOpen && <div className="pb-3">{children}</div>}
    </div>
  );
};

export default FilterAccordion;
